import { useContext } from 'react';
// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import { AuthContext } from 'context/authContext';
import Button from 'components/atoms/Button';
import Paragraph from 'components/atoms/Paragraph';
import Link from 'components/atoms/Link';
import { Flex } from 'styles/helpers.styles';
import LoginTemplate from '../../templates/LoginTemplate';
import Field from '../../molecules/Field';
import Form, { useForm } from '../../molecules/Form';

import { StyledForm, ForgotPassLink } from './Login.styles';

function Login() {
  const [form] = useForm();
  const { onLogin, loading_user } = useContext(AuthContext);
  return (
    <LoginTemplate title="Sign In" subtitle="Welcome back, you’ve been missed!">
      <StyledForm form={form} onSubmit={onLogin}>
        <Form.Item
          bgLight
          type="text"
          label="Email"
          name="email"
          placeholder="Your Email"
          prefix={<i className="material-icons-outlined">email</i>}
          rules={[{ required: true }, { pattern: /^.{0,256}$/, message: 'Maximum Character Length is 256' }]}>
          <Field />
        </Form.Item>
        <Form.Item
          bgLight
          type="password"
          label="Password"
          name="password"
          placeholder="Password"
          prefix={<i className="material-icons-outlined">lock</i>}
          rules={[
            {
              required: true,
            },
          ]}>
          <Field />
        </Form.Item>
        <Flex
          justify="space-between"
          align="middle"
          css="
            margin-bottom: 1.875rem;
            @media (min-width: 768px) {
              margin-bottom: 2.25rem;
            }">
          <Form.Item>
            <Field type="checkbox" label="Remember Me" name="rememberMe" noMargin />
          </Form.Item>
          <ForgotPassLink to="/forgot-password">Forgot Password?</ForgotPassLink>
        </Flex>

        <Button loading={loading_user} type="primary" htmlType="submit">
          Sign in
        </Button>
        <Paragraph lg css="margin-top: 20px;">
          Don&apos;t have an account yet? <Link to="/sign-up">Sign Up</Link>
        </Paragraph>
      </StyledForm>
    </LoginTemplate>
  );
}

export default Login;
